/************************************************** zmf 全局变量 ***************************************************************/

const debug = true;
const copyright = 'Copyright © 2008-2021 Ruijie';
const sortType = {positive:1,inverted:2};

//type汇总 <!-- 资源 -->
const ClassReportType = {resource:1,anser:2,test:3,group_work:4,group_work_des:5};
const DETAIL_TYPE = {quizDetail:1,discussDetail:2,fileDetail:3};
const DEFAULT_DISCUSS_TYPE = {FREE_DISC:20,GROUP_DISC:10};

export default {
	copyright,
	debug,
    sortType,
	ClassReportType,
	DETAIL_TYPE
}




// WEBPACK FOOTER //
// ./src/service/global_variable.js